import React from 'react'
import { Link } from 'gatsby'
import Image from '@components/Image'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'
import { useInView } from 'react-intersection-observer'

const ImageBanner = (props: RealEstateDataPageComponentData) => {
  
  const { title, subtitle, image_gatsby, button, opacityValue, parallax, is_short } = props
  const { ref, inView } = useInView({
    triggerOnce: false, // Cargar solo una vez cuando sea visible
  })

  return (
    <section
      id="image-banner"
      className={"banner " + (parallax ? 'parallax-image' : 'parallax-image')}>
      <div className={"banner-item p-y-config d-flex align-items-center" + (is_short ? " short-banner" : "")}>
        {(opacityValue && opacityValue !== '0') ? (
            <div id="opacity-layer"
              style={{
                opacity:
                  (opacityValue && opacityValue !== '0')
                    ? (Number(opacityValue) !== 100
                      ? `0.${Number(opacityValue)}`
                      : 1) : 0 }}>
              </div>
          ) : null}
        <Image
          className="w-100 no-border position-absolute"
          objectFit="cover"
          alt="image-banner"
          image={image_gatsby!}
        />
          <Container>
            <Row ref={ref} className="text-center">
              {title || subtitle ? (
                <Col
                  xs={12}
                  className={(inView ? ' animate__animated animate__fadeInUp ':'') }
                >
                  {title ? <h2>{title}</h2> : null}
                  {subtitle ? <p className="my-5 px-3 px-lg-0">{subtitle}</p> : null}
                </Col>
              ) : null}
              {button && button?.link ? (
                <Col xs={12}>
                  <Link
                    to={button?.link!}
                    className={"btn btn-white btn-outline" + (subtitle ? "" : " mt-3 ") + (inView ? ' animate__animated animate__fadeInUp ':'')}
                  >
                    {button?.value!}
                  </Link>
                </Col>
              ) : null}
            </Row>
          </Container>
      </div>
    </section>
  )
}

export default ImageBanner
